import { useEffect, useState } from "react";
import { categories } from "@/mocks/articles";

const slides = [
  {
    image: "https://public.readdy.ai/ai/img_res/ce5e7f35fbc2b3296a14c454669dc930.jpg",
    tag: "New Season 2026",
    headline1: "Your Gateway to",
    headline2: "Premium Fashion",
    sub: "HipoBuy 2026 connects you with verified sellers offering fast worldwide shipping, secure payments, and unbeatable prices on shoes, clothing, and accessories.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=high%20fashion%20sneakers%20shoes%20collection%20dark%20studio%20editorial%20photography%20premium%20quality%20cinematic%20lighting%20deep%20contrast&width=1600&height=900&seq=hero102&orientation=landscape",
    tag: "Shoes Collection",
    headline1: "Step Into",
    headline2: "Iconic Style",
    sub: "Explore thousands of premium sneakers and footwear styles. HipoBuy 2026 brings you the hottest drops at prices that make sense.",
  },
  {
    image: "https://readdy.ai/api/search-image?query=streetwear%20hoodie%20jacket%20fashion%20editorial%20dark%20background%20cinematic%20premium%20brand%20photography%20moody%20atmospheric&width=1600&height=900&seq=hero103&orientation=landscape",
    tag: "Clothing & Apparel",
    headline1: "Dress Like",
    headline2: "You Mean It",
    sub: "From hoodies to jackets, t-shirts to tracksuits — HipoBuy 2026 has every style you need to build a wardrobe that turns heads.",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((c) => (c + 1) % slides.length);
        setAnimating(false);
      }, 400);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = slides[current];

  return (
    <section className="relative min-h-[680px] md:min-h-[780px] flex flex-col overflow-hidden">
      {/* BG */}
      <div className="absolute inset-0">
        {slides.map((s, i) => (
          <img
            key={i}
            src={s.image}
            alt="HipoBuy 2026"
            className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-700 ${i === current ? "opacity-100" : "opacity-0"}`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className={`relative z-10 flex-1 flex items-center w-full max-w-7xl mx-auto px-4 md:px-6 py-28 transition-opacity duration-400 ${animating ? "opacity-0" : "opacity-100"}`}>
        <div className="max-w-2xl">
          {/* Tag */}
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-8 bg-amber-400"></span>
            <span className="text-amber-400 text-xs font-bold uppercase tracking-[0.2em]">{slide.tag}</span>
          </div>

          {/* Headline */}
          <h1 className="font-black text-white leading-[1.05] mb-5">
            <span className="block text-4xl md:text-6xl lg:text-7xl">{slide.headline1}</span>
            <span className="block text-4xl md:text-6xl lg:text-7xl text-amber-400 mt-1">{slide.headline2}</span>
          </h1>

          <p className="text-white/65 text-base md:text-lg leading-relaxed mb-9 max-w-lg">
            {slide.sub}
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3 mb-12">
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-amber-500 hover:bg-amber-400 text-white font-bold rounded-full transition-all cursor-pointer whitespace-nowrap text-sm tracking-wide"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line"></i>
              </div>
              Buy It Now
            </a>
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 border border-white/40 text-white hover:border-white hover:bg-white/10 font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap text-sm tracking-wide backdrop-blur-sm"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-truck-line"></i>
              </div>
              HipoBuy Shipping
            </a>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8">
            {[
              { value: "50K+", label: "Happy Customers" },
              { value: "10K+", label: "Products Listed" },
              { value: "150+", label: "Countries Shipped" },
              { value: "24/7", label: "Live Support" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl font-black text-white">{stat.value}</div>
                <div className="text-white/45 text-xs mt-0.5 tracking-wide">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Slide dots */}
      <div className="relative z-10 flex items-center gap-2 max-w-7xl mx-auto px-4 md:px-6 pb-8">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`cursor-pointer transition-all duration-300 rounded-full ${i === current ? "w-8 h-2 bg-amber-400" : "w-2 h-2 bg-white/30 hover:bg-white/60"}`}
          />
        ))}
      </div>

      {/* Quick category bar */}
      <div className="relative z-10 bg-black/40 backdrop-blur-md border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide">
            <span className="text-white/40 text-xs font-semibold uppercase tracking-widest whitespace-nowrap mr-3">Shop:</span>
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-white/70 hover:text-white hover:bg-white/10 text-xs font-medium whitespace-nowrap transition-all cursor-pointer"
              >
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </div>
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
